import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthErrorService {
  private errorSubject = new BehaviorSubject<string | null>(null);
  
  error$ = this.errorSubject.asObservable();

  setErrorMessage(message: string) {
    this.errorSubject.next(message);
  }

  clearErrorMessage() {
    this.errorSubject.next(null);
  }
}